import {Image, ImageSourcePropType, StyleSheet} from 'react-native';

import DisableZoom from '@buncha/components/composites/disableZoom';
import React from 'react';
import {ReactNativeZoomableView} from '@openspacelabs/react-native-zoomable-view';

interface CustomZoomImageProps {
  source: ImageSourcePropType;
  imageStyle?: any;
  containerStyle?: any;
}
const CustomZoomImage: React.FC<CustomZoomImageProps> = ({
  source,
  imageStyle,
}) => {
  return (
    <ReactNativeZoomableView
      zoomEnabled={true}
      maxZoom={3}
      minZoom={1}
      zoomStep={0.5}
      initialZoom={1}
      bindToBorders={true}>
      <DisableZoom />
      <Image
        resizeMode="contain"
        style={[styles.image, imageStyle]}
        source={source}
      />
    </ReactNativeZoomableView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: 300,
    height: 300,
  },
});

export default React.memo(CustomZoomImage);
